import {
  Component,
  Input,
  OnInit,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  AfterViewInit
} from "@angular/core";
import { Headers } from "@angular/http";
import { ModalService } from "../../utilities/modal/modal.service";
import { PruHttpService } from "../../services/pru-http.service";

@Component({
  selector: "pru-finapp-tool-modal",
  templateUrl: "./finapp-tool-modal.component.html",
})
export class FinAppToolModalComponent
  implements OnInit, OnChanges, OnDestroy, AfterViewInit {
  @Input() modalId = "";
  @Input() finAppName: string;
  @Input() extraParams: string;
  @Output() closeModalEmitterFinApp = new EventEmitter<string>();

  alreadyLoaded = false;
  showFinAppTool = false;
  finAppClosed = false;
  finAppClosedEvent = false;
  isModelOpen = false;
  loader = false;

  constructor(
    private modalService: ModalService,
    // private _externalAccountsService: ExternalAccountsService,
    private pruHttpService: PruHttpService // private _externalAccountsService: ExternalAccountsService
  ) {
    // this.isPhase2 = this.sessionService.getItem('aggregation-phase2') ? true : false;
  }

  ngOnInit() {
    if (this.finAppName) {
      this.showFinAppTool = true;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      changes.finAppName &&
      !changes.finAppName.isFirstChange() &&
      changes.finAppName.currentValue
    ) {
      this.showFinAppTool = true;
    }
  }

  ngAfterViewInit() {
    // for close button to emit close event to add goal modal
    const onHidden$ = this.modalService.subscribeToHidden(this.modalId);
    if (onHidden$ !== null) {
      onHidden$.subscribe((res) => {
        if (res && !this.finAppClosedEvent) {
          this.finAppClosed = true;
        }
      });
    }
  }

  ngOnDestroy() {
    this.alreadyLoaded = false;
  }

  openModal() {
    this.showFinAppTool = true;
    this.isModelOpen = true;
    let headers: Headers = new Headers();
    //headers.append('mannually get loading screen to show', '');
    //const options = new LoadingOptions(headers, null, true);
    // if (!this.alreadyLoaded) {
    //   this._externalAccountsService.onRequest('', options);
    // }
    this.modalService.open(this.modalId);
    if (this.finAppClosed) {
      this.finAppClosed = false;
    }
  }

  handleYoodleeError(event: any) {
    // console.log('handleYoodleeError', event);
    this.close(event);
    //this.modalService.open('yoodleeLoginError');
  }

  close(event: any) {
    console.log("newLog", event);
    // let headers: Headers = new Headers();
    // headers.append('mannually get loading screen to show', '');
    // const options = new LoadingOptions(headers, null, true);
    if (event) {
      // this._externalAccountsService.onRequest('', options);
      // console.log(typeof event);
      //if (typeof event === "string") {
        this.closeModalEmitterFinApp.emit(event);
        this.finAppClosedEvent = false;
     // } 
      /* else {
        this.finAppClosedEvent = true;
        this.closeModalEmitterFinApp.emit(event);
      } */
    } else {
      this.closeModalEmitterFinApp.emit("none");
    }
    this.modalService.close(this.modalId);
  }

  hideModalElement(event: boolean) {
    if (event) {
      this.showFinAppTool = false;
      this.finAppClosed = true;
      this.isModelOpen = false;
    } else {
      this.showFinAppTool = true;
      this.finAppClosed = false;
      this.isModelOpen = true;
      this.closeModalEmitterFinApp.emit("logout error");
    }
    // this._externalAccountsService.removeAllCallsFromStack();
  }

  showLoading(event) {
    console.log("showLoadingScreen", event);
    this.loader = event;
  }
  consentCheck(event) {
    console.log("consentAccepted", event);
  }
  closeModal(event) {
    console.log("closeValuePropModal", event);
    this.close(event);
  }
  showError(event) {
    console.log("showErrorHandlingMsg", event);
    this.close(event);
  }
  loadingFinAppComplete(event) {
    console.log("loadingFinAppComplete", event);
    if (event) {
      this.loader = false;
    }
    this.alreadyLoaded = true;
    // setTimeout(() => {
    // this._externalAccountsService.removeAllCallsFromStack();
    // }, 1750);
    if (event === false) {
      this.modalService.close(this.modalId);
    }
  }

  keepSessionAlive(event) {
    if (event) {
      // reset your Sesssion - detected mouse activity within 3 minutes
      //one pix call from here
      // console.warn('detected mouse activity on iFrame - keep user session alive');
      let onepixUrl = "/ucd/images/shield-off-2x.png";
      this.pruHttpService.get(onepixUrl, "OnePix").subscribe(
        (r) => {
          // console.log('session extended with one pix invoke')
        },
        (error) => {
          // console.log('session lost withnon pix failure', error)
        }
      );
    }
  }
}
